module.exports = __webpack_public_path__ + "img/linkedin.8b81f8e8.png";